document.addEventListener('DOMContentLoaded', function () {
    function updateFontSize() {
        // Select the elements with the class 'period'
        const periodElements = document.querySelectorAll('.period');

        if (periodElements) {
            periodElements.forEach(periodElement => {
                // Get the computed font-size of the parent element
                const parentFontSize = window.getComputedStyle(periodElement.parentElement).fontSize;

                // Apply the parent's font-size to the period element
                periodElement.style.fontSize = parentFontSize;
            });
        }
    }

    // Update font size on page load
    updateFontSize();

    // Update font size on window resize
    window.addEventListener('resize', updateFontSize);
});
